<template>
  <div id="alerts" class="container vertical">

      <div :key="alertType" v-for="(alertGroup,alertType) in alerts">
        <div :key='index' v-for="(alert,index) in alertGroup" :class="'alert ' + alertType">
          <div class="alert-wrap">
            <div class="alert-content" v-html="alert"></div>
            <div class="alert-close" @click="removeAlert(alertType,index)">×</div>
          </div>
        </div>
      </div>

  </div>
</template>

<script>
  import store from "./../../store/index"

  export default {
    name: "Alerts",
    computed: {
      alerts() {
        return store.getters.alerts;
      }
    },
    methods: {
      removeAlert(type, index) {
        store.dispatch("removeAlert", {type, index})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Blocks/Alerts.vue